import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import MaskedInput from 'react-input-mask';
import Grid from '@mui/material/Grid';
import styles from './FormInput.module.scss';

interface Props {
  id: string
  name: string
  formItemProps: any
  onValueChanged?: any
}

const FormMaskInputTextField: FC<Props> = (props: Props) => {
  const onInputBlur = (event: any, onBlur: any) => {
    onBlur(event);
    if (props.onValueChanged) {
      props.onValueChanged(event.target.value);
    }
  }

  const onInputChange = (event: any, onChange: any) => {
    onChange(event);
  }

  return (
    <>
      <Controller
        name={props.name}
        {...props.formItemProps}
        render={({ field }) => (
            <Grid
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <MaskedInput
                mask='99:99'
                value={field.value}
                onChange={(event) => onInputChange(event, field.onChange)}
                onBlur={(event) => onInputBlur(event, field.onBlur)}
                alwaysShowMask={false}
                maskChar={''}
                className={styles.maskedInput}
              />
            </Grid>
        )}
      />
    </>
  )
}

export default FormMaskInputTextField;
